import React, { useState, useEffect } from 'react';
import { API, sendDataBody } from '../../resources';
import { Calendar, dayjsLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import dayjs from 'dayjs';
import 'dayjs/locale/es-mx'
import CreateCita from './create-cita-for-medic';
import Loading from '../../loading';
import DetailsCita from './details-cita';
import RegisterPatientReception from './register.patient';
import { Card, Typography } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';

dayjs.locale('es-mx')
const localizer = dayjsLocalizer(dayjs)

// admin and receipt shares hospital-tab.citas and create-cita-for-medic and details.cita
// ONLY RECEIPT CANT DELETE, SO, FIRST EDIT RECEIPTIONIST

const HospitalTab = ({ id_hospital, hospital }) => {

    const [citaForEdit, setCitaForEdit] = useState({})
    const [isModalOpen, setIsModalOpen] = useState(false)
    const showModal = () => setIsModalOpen(true)

    const [fecha_hora, setFecha_hora] = useState('')
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)
    const [idsMedicos, setIdsMedicos] = useState([])
    const [serviceList, setServiceList] = useState([])
    const [citasData, setCitasData] = useState(null)
    const [initialDates, setInitialDates] = useState(null)

    useEffect(() => {
        getMedicosData()
    }, [])

    const getMedicosData = () => {
        fetch(API + `users/hospital/${id_hospital}`)
            .then(response => response.json())
            .then(medicosResponse => {
                console.log('Medicos response ', medicosResponse)
                let allServices = []
                const idmeds = medicosResponse.map(doc => {
                    if (doc.configuracion?.tratamientos_ofrecidos)
                        allServices = allServices.concat(doc.configuracion.tratamientos_ofrecidos)
                    return doc._id
                })
                setIdsMedicos(idmeds)
                setServiceList(allServices)

                const now = new Date()
                const start = new Date(now); start.setDate(now.getDate() - 7)
                const end = new Date(now); end.setDate(now.getDate() + 7)
                setInitialDates({ start_date: start, end_date: end })
                getCitasData(start, end, allServices)
            })
            .catch(error => console.error('Error:', error))
    }

    const getCitasData = async (_start_date = initialDates?.start_date, _end_date = initialDates?.end_date, services = serviceList) => {
        await sendDataBody(`citas/sucursal/${id_hospital}`, { start_date: _start_date, end_date: _end_date })
            .then((data) => {
                const rs = Array.isArray(data) ? data : []
                rs.forEach((cita) => {
                    const servicioInfo = services.find(s => s._id === cita.id_servicio)
                    if (servicioInfo) cita.color = servicioInfo.color
                    cita.start = new Date(Date.parse(cita.fecha_hora))
                    const endDate = new Date(Date.parse(cita.fecha_hora))
                    endDate.setTime(endDate.getTime() + (cita.duracion ?? 60) * 60 * 1000)
                    cita.end = endDate
                    cita.title = cita.usuario?.name
                    cita.key = cita._id
                })
                console.log('Citas data all --------- ', rs)
                setCitasData(rs)
            })
    }

    const selectEvent = (e) => {
        if (!e.doctor) e.doctor = e.medico
        if (!e.paciente) e.paciente = e.usuario
        if (e.medico && e.medico._id) e.medico = e.medico._id
        if (e.usuario && e.usuario._id) e.usuario = e.usuario._id
        e.fecha_hora = dayjs(e.fecha_hora)
        setCitaForEdit(e)
        if (citaForEdit) showModal()
    }

    const handleSlotSelection = ({ start }) => {
        setFecha_hora(dayjs(start))
        setIsCreateModalOpen(true)
    }

    const eventStyleGetter = (event) => ({
        style: {
            backgroundColor: event.color || '#1677ff',
            borderRadius: '6px',
            opacity: 0.9,
            color: 'white',
            border: '0px',
            display: 'block',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            padding: '2px 4px',
            fontWeight: 500
        }
    })

    if (citasData === null) return <Loading />
    return (
        <div style={{ padding: '24px', background: '#f5f7fa', minHeight: '100vh' }}>

            <RegisterPatientReception getPacientesData={getCitasData} />

            <Card
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{ padding: '10px', background: '#e6f4ff', borderRadius: '10px', display: 'flex' }}>
                            <CalendarOutlined style={{ fontSize: '24px', color: '#1677ff' }} />
                        </div>
                        <Typography.Title level={3} style={{ margin: 0, color: '#1f1f1f' }}>Citas de Sucursal</Typography.Title>
                    </div>
                }
                bordered={false}
                style={{ borderRadius: '16px', boxShadow: '0 4px 24px -8px rgba(0,0,0,0.05)', marginTop: '24px' }}
            >
                <Calendar
                    scrollToTime={new Date(Date.now())}
                    selectable='true'
                    localizer={localizer}
                    events={citasData}
                    eventPropGetter={eventStyleGetter}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: '70vh', minHeight: 600 }}
                    messages={{ next: "Sig", previous: "Ant", today: "Hoy", month: "Mes", week: "Semana", day: "Día" }}
                    defaultView="week"
                    onDoubleClickEvent={(e) => console.log(e)}
                    onSelectEvent={selectEvent}
                    onSelecting={(e) => console.log(e)}
                    onSelectSlot={handleSlotSelection}
                    onRangeChange={(range) => {
                        if (range.start && range.end) {
                            getCitasData(range.start, range.end)
                        } else if (Array.isArray(range)) {
                            const endDate = new Date(range.at(-1))
                            endDate.setHours(23, 59, 59, 999)
                            getCitasData(range[0], endDate)
                        }
                    }}
                />
            </Card>

            <DetailsCita citaForEdit={citaForEdit} getCitasData={getCitasData} id_hospital={id_hospital} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} idsMedicos={idsMedicos} />

            <CreateCita setIsModalOpen={setIsCreateModalOpen} isOpenModal={isCreateModalOpen} hospital={id_hospital} fecha_hora={fecha_hora} getCitasData={getCitasData} idsMedicos={idsMedicos} />

        </div>
    )
}

export default HospitalTab;
